import { CallerIcon, DepartmentIcon } from 'assets';
import { Typography } from '../../../common';
import './switchHeader.scss';

type SwitchHeaderProps = {
  activeTab: 'departments' | 'agents';
  setActiveTab: (tab: 'departments' | 'agents') => void;
};

const SwitchHeader = ({ activeTab, setActiveTab }: SwitchHeaderProps) => {
  return (
    <div className="section-header-container">
      <div
        className={`tab-container department-tab ${activeTab === 'departments' ? 'active' : ''}`}
        onClick={() => setActiveTab('departments')}
      >
        <div className="dep-icon"><img src={DepartmentIcon} alt='department-icon'/></div>
        <div className="dep-heading-subheading">
          <div className="dep-heading">
            <Typography variant="subHeading-1">Departments</Typography>
          </div>
          <div className="dep-subHeading">
            <Typography variant="small-text-4">3/3</Typography>
          </div>
        </div>
      </div>

      <div
        className={`tab-container agents-tab ${activeTab === 'agents' ? 'active' : ''}`}
        onClick={() => setActiveTab('agents')}
      >
        <div className="agents-heading-subheading">
          <div className="agents-heading">
            <Typography variant="subHeading-1">Agents</Typography>
          </div>
          <div className="agents-subHeading">
            <Typography variant="small-text-4">1 Answered Call  13 Waiting</Typography>
          </div>
        </div>
        <div className="agent-icon"><img src={CallerIcon} alt='caller-icon'/></div>
      </div>
    </div>
  );
};

export default SwitchHeader;
